<template>
  <div class="nav-link">
    <Button
      text
      :to="href"
      :href="`#${id}`"
      @click.prevent="scrollTo"
      :class="isActive && 'active'"
    >
      {{ name }}
    </Button>
  </div>
</template>

<script>
/**
 * @author Cameron Bulock <cameron.bulock@quavo.com>
 */

import Button from "@/qux-common/qux22/components/molecules/button";

export default {
  name: "NavigationLink",
  components: { Button },
  props: {
    name: {
      type: String,
    },
    href: {
      type: String,
    },
    id: {
      type: String,
    },
  },
  methods: {
    scrollTo() {
      const anchor = document.getElementById(this.id);
      anchor.scrollIntoView({ behavior: "smooth" });
      this.$router.push({ hash: `#${this.id}` });
    },
  },
  computed: {
    isActive() {
      return this.$route.hash === `#${this.id}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.button.v-btn:not(.v-btn--round).v-btn--text {
  &.active {
    &::v-deep {
      .v-btn__content .label {
        color: $qvo-color-grey-900;
      }
    }
  }
}
</style>